var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('TheHeader'),_c('HeroSection'),_c('ServicosBox'),_c('OfertasEspeciais'),_c('CardapioImperial'),_c('AtendimentoPersonalizado'),_c('NossaRealeza'),_c('PublicacoesInstagram'),_c('NossasEntregas'),_c('NossoCastelo'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }